import { Descriptions, Divider } from 'antd';
import _ from 'lodash';
import React from 'react';
import nextId from 'react-id-generator';
import { useTranslation } from 'react-i18next';
import { ClaimItem } from '../../../services/calc/claim';
import { PartialResult } from '../../../store/sumUp';
import { RowExt, DescFullWidth } from '../../../styles';
import { formatDate } from '../../../utils/helpers/date';
import { formatPLN } from '../../../utils/helpers/formatNumber';
import { DetailsPeriodResult } from './DetailsInterestsPeriods';

const { Item: DescItem } = Descriptions;

const DetailsFulfilledInterestPeriods = ({ claim }: {
  claim: ClaimItem | PartialResult,
}) => {
  const { t } = useTranslation();
  if (_.isEmpty(claim.interestResultsFulfilled)) return null;
  return (
    <>
      <Divider>
        {t('detailsFulfilledInterestPeriods.title')}
      </Divider>
      {claim.interestResultsFulfilled.map((result, index) => {
        return (
          <>
            <RowExt marginBottom="md">
              <DescFullWidth layout="horizontal" bordered key="d">
                <DescItem label={t('detailsFulfilledInterestPeriods.basis')} span={3}><strong>{`${formatPLN(claim.interestDataFulfilled[index]?.partialSum)}`}</strong></DescItem>
              </DescFullWidth>
            </RowExt>
            {result.periodResults.map((periodResult) => {
              return (
                <DetailsPeriodResult
                  key={nextId()}
                  periodResult={periodResult}
                />
              );
            })}
            <RowExt marginTop="md">
              <DescFullWidth layout="horizontal" bordered key="d">
                <DescItem
                  label={`${t('detailsFulfilledInterestPeriods.total')} ${`${t('detailsFulfilledInterestPeriods.period')} ${formatDate(_.last(result.periodResults)?.periodEnd ?? '')}`}`}
                  span={3}
                >
                  <strong>{`${formatPLN(result.interestSum)}`}</strong>
                </DescItem>
              </DescFullWidth>
            </RowExt>
            <Divider />
          </>
        );
      })}
    </>
  );
};

export default DetailsFulfilledInterestPeriods;